import Button from "../components/button/Button"
import FAQItem from "../components/questions/Questions"
import WhoDoesList from "../components/time/Time"
import styles from "./FifthScreen.module.css"

const FifthScreen = () => {
  return (
    <>
      <div className={styles.title}>
 ״הילה… איך אני אדע אם זה הזמן להתחיל תהליך שיווק ובניית תשתית של תוכן שמביא לידים?״
      </div>

      <div className={styles.description}>האמת? אולי זה יפתיע אותך, אבל
 לא כל בעל עסק צריכה להתחיל מיד ליווי שיווקי,
 ובטח שלא כל מי שיוצר תוכן צריך ישר לרוץ ליום צילום. <br/>
אז בואי נעשה סדר ↓
 אתם כנראה בשלב הנכון לתהליך כזה אם:</div>

     <WhoDoesList/>
         <div className={styles.description}>אם זיהיתם את עצמכם ב־2-3 מהקוביות,
יש סיכוי טוב שתהליך ה־90 יום לבניית תשתית תוכן שמחמם לידים -
הוא בדיוק מה שהעסק שלכם צריך עכשיו.
</div>
     <Button text="הילה, אני בפנים!"/>
    </>
  )
}

export default FifthScreen
